import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject, fromEvent, timer } from 'rxjs';
import { debounce, tap, map, distinctUntilChanged } from 'rxjs/operators';
import { Destroy } from '@web-bankir/ui-kit/helpers/abstractions';
import { browserMethod } from '@web-bankir/ui-kit/helpers/decorators';
var Device = /*#__PURE__*/function (Device) {
  Device[Device["Mobile"] = 0] = "Mobile";
  Device[Device["Tablet"] = 1] = "Tablet";
  Device[Device["Desktop"] = 2] = "Desktop";
  return Device;
}(Device || {});
var BreakpointAlias = /*#__PURE__*/function (BreakpointAlias) {
  BreakpointAlias["DEFAULT"] = "default";
  BreakpointAlias["XS"] = "xs";
  BreakpointAlias["SM"] = "sm";
  BreakpointAlias["MD"] = "md";
  BreakpointAlias["LG"] = "lg";
  BreakpointAlias["XL"] = "xl";
  return BreakpointAlias;
}(BreakpointAlias || {});
var BreakpointBound = /*#__PURE__*/function (BreakpointBound) {
  BreakpointBound["Mobile"] = "md";
  BreakpointBound["Tablet"] = "xl";
  return BreakpointBound;
}(BreakpointBound || {});
let DeviceService = /*#__PURE__*/(() => {
  class DeviceService extends Destroy {
    get isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent);
    }
    constructor(window) {
      super();
      this.window = window;
      this.device$ = new BehaviorSubject(undefined);
      this.webView$ = new BehaviorSubject(undefined);
      this.breakpoints$ = new BehaviorSubject(undefined);
      this.currentBreakpoints$ = new BehaviorSubject([]);
    }
    init() {
      this.webView$.next(this.detectWebView());
      this.breakpoints$.next(this.calcBreakpoints());
      this.currentBreakpoints$.next(this.calcCurrectBreakpoints());
      this.device$.next(this.calcDevice());
      fromEvent(this.window, 'resize').pipe(debounce(() => timer(300)), tap(() => this.currentBreakpoints$.next(this.calcCurrectBreakpoints())), map(() => this.calcDevice()), distinctUntilChanged(), tap(device => this.device$.next(device))).subscribe();
    }
    notAppleMobileDevice() {
      return !/iphone|ipod|ipad/.test(this.window.navigator.userAgent.toLowerCase());
    }
    detectWebView() {
      return !!new URL(this.window.location.href).searchParams.get('wv');
    }
    calcDevice() {
      const size = this.window.innerWidth;
      if (size < this._breakpoints[BreakpointBound.Mobile]) {
        return Device.Mobile;
      } else if (size < this._breakpoints[BreakpointBound.Tablet]) {
        return Device.Tablet;
      } else {
        return Device.Desktop;
      }
    }
    calcBreakpoints() {
      const breakpoints = {};
      for (const key in BreakpointAlias) {
        const value = BreakpointAlias[key];
        breakpoints[value] = +this.window?.getComputedStyle(this.window.document.body).getPropertyValue(`--${value}`).replace('px', '');
      }
      this._breakpoints = breakpoints;
      return this._breakpoints;
    }
    calcCurrectBreakpoints() {
      return Object.keys(this._breakpoints)
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      .filter(key => this._breakpoints[key] < this.window.innerWidth);
    }
    static {
      this.ɵfac = function DeviceService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || DeviceService)(i0.ɵɵinject('Window'));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DeviceService,
        factory: DeviceService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  __decorate([browserMethod()], DeviceService.prototype, "init", null);
  __decorate([browserMethod()], DeviceService.prototype, "notAppleMobileDevice", null);
  return DeviceService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { BreakpointAlias, BreakpointBound, Device, DeviceService };
